<script setup lang="ts">
import type { PropType } from 'vue'

const props = defineProps({
  text: { type: String, required: true },
  size: { type: String, required: false, default: 'small' },
  color: { type: String, required: false, default: '#757575' },
  vClass: { type: String, required: false },
  maxWidth: { type: String, required: false, default: '550px' },
  location: {
    type: String as PropType<'start' | 'end' | 'top' | 'bottom'>,
    required: false,
    default: 'bottom'
  },
  image: { type: String, required: false },
  title: { type: String, required: false },
  backgroundColor: { type: String, required: false, default: '#D9D9D9' }
})

const isValidImage = computed(() => props.image && props.image.startsWith('/'))
</script>

<template>
  <v-tooltip
    :location="props.location"
    :max-width="props.maxWidth"
    :style="{
      zIndex: 9999,
      position: 'absolute',
      colorScheme: '#D9D9D9'
    }"
  >
    <template v-slot:activator="{ props }">
      <v-icon v-bind="props" :color="color" :class="props.vClass" :size="props.size">
        mdi-information-slab-circle-outline
      </v-icon>
    </template>
    <div
      style="
        padding: 16px;
        border-radius: 8px;
        color: black;
        overflow: hidden;
        font: bold;
        display: block;
        position: relative;
      "
    >
      <img
        v-if="isValidImage"
        :src="props.image"
        alt="Help Image"
        style="
          float: right;
          max-width: 220px;
          height: auto;
          object-fit: contain;
          margin-left: 20px;
          margin-bottom: 10px;
          border-radius: 4px;
          background-color: #d9d9d9;
        "
      />
      <div style="flex: 1">
        <div
          v-if="props.title"
          :style="{
            fontSize: '1.2em',
            fontWeight: 'bold',
            marginBottom: '8px'
          }"
        >
          {{ props.title }}
        </div>
        <div v-html="props.text"></div>
      </div>
    </div>
  </v-tooltip>
</template>

<style scoped>
::v-deep(.v-overlay__content) {
  background-color: #d9d9d9 !important;
}
</style>
